import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, Link, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

function ViewKdAsRm(props) {
    let history = useHistory();
    const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const { state } = props.location;
	const [kdData] = useState(state[0]);
    const [allData] = useState(state[1]);
    const [d, setData] = useState({});
    const [error1, setError] = useState(false);
    const [redirect,setRedirect] = useState("");
    useEffect(() => {
		getKdData();
	}, []);

    const getKdData = async () => {
        const requestOptions = {
            method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id},
			body: JSON.stringify({dist_user_id:user_id,kd_id:kdData.kd_id}),
		};

		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-kingdom-details', requestOptions);
		var data = await response.json();
		if (data.status !== "success"){
            setError(true);
		}
        data.kd_name = kdData.kd_name;
        localStorage.setItem('chat_users', JSON.stringify(data.chat_data));
        localStorage.setItem('cg_id', JSON.stringify(data.cg_id));
        setData(data);

    }

    function closeMOdal(){
		setRedirect(<Redirect to={{
			pathname:"/share-kingdom",
			state: [allData, kdData]
		}}  />);
	}

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/kingdom-as-rm.css'}]
	}/>
    <div className="row no-gutters">
	{ error1 === false && (
      	<div className="application" style={{backgroundColor:`#E5E5E5` }}>
        	
			<div 
				style = {{
				height: `200px`,
				backgroundImage: `url(${kdData.kd_image}) `,
				backgroundSize: `100% 100%`,
				// borderBottomLeftRadius: `8px`,
				// borderBottomRightRadius: `8px`,
				// backgroundAttachment: `fixed`,
				display: `block`,
				}}
			>
			<div className="appHeader bg-transparent text-light position-relative">
				<div className="left">
					<a className="headerButton goBack" onClick={() => history.goBack()}>
						<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
					</a>
				</div>
				<div className="pageTitle">&nbsp;</div>
				<div className="right">
					<a className="headerButton"  data-toggle="modal" data-target="#bottom_modal">
						<img src={require("./../images/share.png").default} alt="faq" className="img-fluid" />
                        {/* <i className="bi bi-share"></i> */}
					</a>
				</div>
				<div className="section">
					<div className="header-app text-left">
						<p className="mb-0 app-header">
							Kingdom <br />
						</p>
						<p className="mb-0 app-sub-header">
							{kdData.kd_name}
						</p>
					</div>            
				</div>


                <div className="card" style={{
                            marginTop:`80px`,
                            // height:`50px`,
                            boxShadow:`none`,
                            borderBottomLeftRadius: `0px`,
                            borderBottomRightRadius: `0px`,
                            borderTopLeftRadius: `30px`,
                            borderTopRightRadius: `30px`,
                            backgroundColor:`#E5E5E5` 
                        }}>
                    <div className="card-body">
                        <h5> {"Details of Kingdom " + kdData.kd_name} </h5>
                    </div>
                </div>
			</div>
        </div>
        <div className="section" style={{marginTop:`50px`,borderRadius:`10px`,backgroundColor:`white`, marginRight:`20px`,marginLeft:`20px`}}>
            <div className="row"  style={{marginTop:`20px`}} ></div>
            {/* <div className="row"  style={{marginTop:`40px`}} >
                <div  className="col-1"></div>
                <div className="col-1" style = {{
                    backgroundImage: `url(${require("./../images/level-icon.png").default} ) `,
                    backgroundSize: `100% 100%`,
                    display: `block`,
                    }}>
                </div>
                <div className="col-7" style={{marginTop:`5px`}} > <b>Level </b></div>
                <div className="col-2" style={{marginTop:`5px`}} ><b>{kdData.level}</b></div>
            </div>
            <div className="row" style={{marginTop:`40px`}}>
                <div  className="col-1"></div>
                <div className="col-1" style = {{
                    backgroundImage: `url(${require("./../images/wealth-Icon.png").default} ) `,
                    backgroundSize: `100% 100%`,
                    display: `block`,
                    }}>
                </div>
                <div className="col-7" style={{marginTop:`5px`}} > <b>Wealth</b></div>
                <div className="col-2" style={{marginTop:`5px`}} ><b>{d.kd_wealth}</b></div>
            </div> */}
            <div className="row" style={{marginTop:`40px`}} >
                <div  className="col-1"></div>
                <div className="col-1" style = {{
                    backgroundImage: `url(${require("./../images/Wars-won-icon.png").default} ) `,
                    backgroundSize: `100% 100%`,
                    display: `block`,
                    }}>
                </div>
                <div className="col-7" style={{marginTop:`5px`}} > <b>Wars Won</b></div>
                <div className="col-2" style={{marginTop:`5px`}} >
                    <p className="mb-0">
                        <b>{d.kd_win_war}/</b>
                        <span className="half-font"><b>{d.kd_total_war}</b></span>
                    </p>
                </div>
            </div>
            <div className="row"  style={{marginTop:`20px`}} ></div>
        </div>
        <div className="section">
            <div className="button-group" style={{marginTop:`40px`}}>
                {/* <Link to={{
                            pathname:"/kingdom-stats",
                            state: [d]
                        }} className="btn btn-red btn-block btn-lg mb-2"> */}
                <p className="btn btn-red btn-block btn-lg mb-2" data-toggle="modal" data-target="#bottom_modal_new_kd_stats">
                    My Kingdom Stats
                    <img src={require("./../images/right-arrow.png").default} alt="rarrow" className="img-fluid" />
                </p>
                {/* </Link> */}
                <Link to={{
                            pathname:"/chat",
                            state: [d,"first", ""]
                        }} className="btn btn-blue btn-block btn-lg">
                    Group Updates
                    <img src={require("./../images/group-chat-arrow.png").default} alt="carrow" className="img-fluid" />
                </Link>
            </div>
        </div>
        <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                        <h5 className="modal-title">Share this kingdom</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                            <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                        </button>
                    </div>
                    <div className="modal-body px-34">
                        <img src={kdData.kd_image} alt="image" className="imaged w69 rounded"/>
                        <p className="mb-0 text-black">Kingdom {kdData.kd_name}</p>
                        <p className="mb-0 desc">Suggest your distributors to go for a war with<br /> this kingdom.</p>
                        <div className="row justify-content-center my-3">
                            <div className="col-8 col-md-8 col-lg-8" >
                                <a className="btn btn-apply btn-block"
                                onClick={() =>closeMOdal()}
                                data-dismiss="modal" aria-label="Close" >
                                    Share in group chat
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal bottom fade" id="bottom_modal_new_kd_stats" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                        <h5 className="modal-title">View kingdom stats</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                            <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                        </button>
                    </div>
                    <div className="modal-body px-34">
                        <p className="mb-0 desc">This is only available on the day of war.</p>
                    </div>
                </div>
            </div>
        </div>
        {redirect}
      </div>
	  )}
	  { error1 === true && (
		  <Redirect to='/'  />
	  )}
	  <div className="bg"></div>
    </div>
</>
    );
}

export default ViewKdAsRm;
